import { render } from "./ProcessedSinglesOverview.vue?vue&type=template&id=87eacda6&scoped=true"
import script from "./ProcessedSinglesOverview.vue?vue&type=script&lang=js"
export * from "./ProcessedSinglesOverview.vue?vue&type=script&lang=js"

import "./ProcessedSinglesOverview.vue?vue&type=style&index=0&id=87eacda6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87eacda6"]])

export default __exports__